module.exports = __webpack_public_path__ + "static/sliderOne-690f7a625d4a8656627738258fd13267.jpg";